export const LEFT_SPACE_CODE = "leftSpaceCode";
export const LEFT_CODE = "leftCode";
export const RIGHT_CODE = "rightCode";
export const RIGHT_SPACE_CODE = "rightSpaceCode";
export const LEFT_CODE_SYMBOL = "leftCodeSymbol";
export const LEFT_CODE_SYMBOL_SPACE = "leftCodeSpaceSymbol";
export const LEFT_AMOUNT_CODE = "leftAmountCode";
export const LEFT_AMOUNT_SPACE_CODE = "leftAmountSpaceCode";
export const CODE_AMOUNT_CODE = "codeSpaceAmountSpaceCode";
